import React from 'react';
import { Box, Flex, Heading, Tooltip } from '@chakra-ui/react';
import { InfoOutlineIcon } from '@chakra-ui/icons';

import type { BoxProps } from '@chakra-ui/react';

/**
 * A simple card component, mainly to quickly swap out with the @smeargle Card component in lieu of
 * major redesigns.
 */

type CardProps = {
  headingText?: string;
  HeadingProps?: Record<string, any>;
  tooltip?: string;
  children?: React.ReactNode;
  headingChildren?: React.ReactNode;
} & BoxProps;

export const Card = ({ headingText, HeadingProps, tooltip, children, headingChildren, ...rest }: CardProps) => (
  <Box borderWidth={1} borderRadius={4} p={4} backgroundColor="white" overflow="auto" {...rest}>
    <Flex gap={2} mb={2} justifyContent="space-between">
      {(headingText || tooltip) && (
        <Flex alignItems="center" gap={2} mb={2}>
          <Heading as={'h3'} size="sm" {...HeadingProps}>
            {headingText}
          </Heading>
          {tooltip && (
            <Tooltip label={tooltip} placement="top" hasArrow>
              <InfoOutlineIcon color="content-secondary" />
            </Tooltip>
          )}
        </Flex>
      )}
      {headingChildren}
    </Flex>

    {children}
  </Box>
);
